import { Injectable, NgZone } from '@angular/core';
import { BodyOutputType, Toast, ToasterConfig, ToasterService } from 'angular2-toaster';

import { TransPipe } from '../../pipes/trans.pipe';

@Injectable()
export class ToastService {
  constructor(
    private readonly zone: NgZone,
    private readonly toasterService: ToasterService,
    private readonly translate: TransPipe
  ) {
  }

  getConfiguration(): ToasterConfig {
    return new ToasterConfig({
      positionClass: 'toast-top-right',
      timeout: 30000,
      newestOnTop: true,
      tapToDismiss: true,
      preventDuplicates: true,
      animation: 'fade',
      limit: 5
    });
  }
  async showToast(type: string, title: string, body: string, functionExec?: any, context?: any, infoLead?: { leadId?: string, companyId?: string }): Promise<void> {
    const toast: Toast = {
      type,
      title: this.translate.transform(title),
      body: this.translate.transform(body),
      timeout: 5000,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      clickHandler: (_t, isClosed): boolean => {
        if (!isClosed && functionExec) {
          functionExec(context, infoLead);
        }

        return true;
      }
    };
    this.zone.run(() => {
      this.toasterService.popAsync(toast);
    });
  }

  showToastJWTExpired(type: string, title: string, body: string): void {

    const toast: Toast = {
      type,
      title: this.translate.transform(title),
      body: this.translate.transform(body),
      timeout: 0,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml
    };
    this.zone.run(() => {
      this.toasterService.popAsync(toast);
    });
  }

  showToastWithConfig(config: Toast): void {

    const toast: Toast = {
      type: 'error',
      timeout: 5000,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml
    };
    this.zone.run(() => {
      this.toasterService.popAsync({ ...toast, ...config });
    });
  }

}
